import { useState } from "react";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Progress } from "@/components/ui/progress";
import { restoreBackup, formatBackupDate } from "@/lib/backup";

export function RestoreBackupForm({ onBack, onDone }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [file, setFile] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!file) return setError("Seleziona il file di backup (.json.gz)");
    if (!confirm) return setError("Conferma la sostituzione dei dati attuali per procedere");
    setProgress(0);
    try {
      const res = await restoreBackup({ file, email: email.trim(), password, onProgress: setProgress });
      toast.success(`Ripristino completato dal backup del ${formatBackupDate(res.backup_created_at)}: ${res.documents} record e ${res.files} documenti.`);
      onDone(email.trim());
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, err));
      setProgress(null);
    }
  };

  const running = progress !== null;
  return (
    <form onSubmit={submit} className="w-full login-card p-8 text-[#09090b]" data-testid="restore-card">
      <h2 className="font-display font-bold text-2xl tracking-tight">Ripristina da backup</h2>
      <p className="data-label mt-2 mb-6">Carica un file di backup scaricato dall'app. Tutti i dati attuali verranno sostituiti.</p>

      <label className="data-label block mb-1">Email amministratore</label>
      <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@azienda.it" className="mb-4" required data-testid="restore-email-input" />
      <label className="data-label block mb-1">Password</label>
      <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mb-4" required data-testid="restore-password-input" />
      <label className="data-label block mb-1">File di backup</label>
      <input type="file" accept=".gz,.json,application/gzip,application/json" onChange={(e) => setFile(e.target.files?.[0] || null)} className="text-sm mb-4 block w-full" data-testid="restore-file-input" />
      <label className="flex items-start gap-2 text-xs mb-5 cursor-pointer">
        <input type="checkbox" checked={confirm} onChange={(e) => setConfirm(e.target.checked)} className="mt-0.5 accent-[#cc0033]" data-testid="restore-confirm-checkbox" />
        <span>Confermo: i dati presenti nell'app saranno sostituiti con quelli del backup.</span>
      </label>

      {running && <Progress value={progress} className="mb-4 h-2" data-testid="restore-progress" />}
      {error && <p className="text-destructive text-sm mb-4 font-medium" data-testid="restore-error-message">{error}</p>}

      <Button type="submit" disabled={running} className="w-full bg-[#cc0033] text-white hover:bg-[#a30028]" data-testid="restore-submit-button">
        {running ? `Ripristino in corso… ${progress}%` : "Avvia ripristino"}
      </Button>
      <button type="button" onClick={onBack} disabled={running} className="text-xs text-zinc-500 hover:underline mt-4 block mx-auto" data-testid="restore-back-to-login-link">
        ← Torna al login
      </button>
    </form>
  );
}
